const getDefaultState = () => {
  return {
    isDragging: false,
    dragItem: null,
    dragCol: -1,
    dragRow: -1,
    selectedCol: -1,
    selectedRow: -1,
  };
};

// initial state
const state = getDefaultState();

// mutations
const mutations = {
  setIsDragging(state, isDragging) {
    state.isDragging = isDragging;
  },
  setDragItem(state, item) {
    state.dragItem = item;
  },
  setDragCol(state, dragCol) {
    state.dragCol = dragCol;
  },
  setDragRow(state, dragRow) {
    state.dragRow = dragRow;
  },
  setSelectedCol(state, col) {
    state.selectedCol = col;
  },
  setSelectedRow(state, row) {
    state.selectedRow = row;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
